export const colors = {
    transparent: 'transparent',
    text: '#ffffffde',
    background: '#0D1B2A',
    backgroundEmphasized: '#24303f',
    divider: '#666e78',

    'primary-100': '#4E251A',
    'primary-500': '#F96A42',

    'secondary-100': '#29285F',
    'secondary-400': '#3e3ac5',
    'secondary-500': '#6F6BFF',

    'warning-100': '#5A3A28',
    'warning-500': '#F6C755',

    'success-100': '#243A2B',
    'success-400': '#479468',
    'success-500': '#55BB82',
    'success-600': '#6ec797',

    'error-200': '#642321',
    'error-500': '#EB4E48',

    'grey-100': '#33363E',
    'grey-300': '#585D6B',
    'grey-500': '#81899D',
    'grey-800': '#e9eaee'
};
